module.exports = __webpack_public_path__ + "img/swift-hesperange-logo-icon.5a481233.png";